import { render, staticRenderFns } from "./FlashSaleCreate.vue?vue&type=template&id=3c1d1546&scoped=true&"
import script from "./FlashSaleCreate.vue?vue&type=script&lang=js&"
export * from "./FlashSaleCreate.vue?vue&type=script&lang=js&"
import style0 from "./FlashSaleCreate.vue?vue&type=style&index=0&id=3c1d1546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1d1546",
  null
  
)

export default component.exports